module.exports = {"512022100":"天池镇","512022101":"石佛镇","512022102":"回澜镇","512022103":"石湍镇","512022104":"童家镇","512022105":"宝林镇","512022106":"大佛镇","512022107":"良安镇","512022108":"金顺镇","512022109":"中和场镇","512022110":"劳动镇","512022111":"中天镇","512022112":"佛星镇","512022113":"蟠龙镇","512022114":"东山镇","512022115":"通旅镇","512022116":"高寺镇","512022200":"龙溪乡","512022201":"全胜乡","512022202":"孔雀乡","512022203":"龙门乡","512022204":"双河场乡","512022205":"放生乡","512022206":"盛池乡","512022207":"凉水乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/512022.json
// module id = 2396
// module chunks = 0